import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Spin, notification } from 'antd';
import { useGetFormDetailsQuery, useGetFormQuestionsQuery } from '../../../store/api/apiSlice';

const SurveyFlow = () => {
  const { formId } = useParams();
  const navigate = useNavigate();

  const { 
    data: formData, 
    isLoading: formLoading, 
    error: formError 
  } = useGetFormDetailsQuery(formId);

  const { 
    data: questionsData, 
    isLoading: questionsLoading,
    error: questionsError 
  } = useGetFormQuestionsQuery(formId);

  useEffect(() => {
    const handleNavigation = () => {
      // Only proceed if we have both form and questions data
      if (!formData?.data || !questionsData?.data) return;

      // Check if there are any questions
      if (!questionsData.data.length) {
        notification.error({
          message: 'No Questions Found',
          description: 'This form does not have any questions.'
        });
        return;
      }

      try {
        // Find intro question
        const introQuestion = questionsData.data.find(q => q.is_intro);
        
        if (introQuestion) {
          navigate(`/admin/intro/${formId}`);
        } else {
          const firstQuestion = questionsData.data[0];
          if (firstQuestion?.number) {
            navigate(`/admin/question/${formId}/0`);
          } else {
            navigate(`/admin/question/${formId}/0`);

            // notification.error({
            //   message: 'Invalid Question',
            //   description: 'Could not find a valid question number.'
            // });
          }
        }
      } catch (error) {
        console.error('Navigation error:', error);
        notification.error({
          message: 'Error',
          description: 'Failed to process form data.'
        });
      }
    };

    // Only run navigation when both queries are complete and successful
    if (!formLoading && !questionsLoading && !formError && !questionsError) {
      handleNavigation();
    }
  }, [
    formData, 
    questionsData, 
    formLoading, 
    questionsLoading, 
    formId, 
    navigate,
    formError,
    questionsError
  ]);

  // Handle loading state
  if (formLoading || questionsLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Spin size="large" />
      </div>
    );
  }

  // Handle errors
  if (formError || questionsError) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <h2 className="text-xl font-bold text-gray-900 mb-2">Error Loading Form</h2>
          <p className="text-gray-500">
            {formError?.message || questionsError?.message || 'Failed to load form data'}
          </p>
        </div>
      </div>
    );
  }

  return null;
};

export default SurveyFlow;